import {
  getOperateCityList,
  getOperateCityAreaList,
  getOperateAreaRoadList,
  getOperateRoadSectionsList,
  byAreaCodeGetParkingLotList
} from "@/api/common";

import {
  getCityPage,
  byCityGetArea,
  baseAreaList
} from "@/api/Advertisement/AdvertisingSpace";

// 过滤类型列表
const filterTypes = {
  city: ["city"],
  area: ["city", "area"], // 城市/区域
  road: ["city", "area", "road"], // 城市/区域/道路
  roadSection: ["city", "area", "road", "roadSection"], // 城市/区域/道路/路段
  parkingLot: ["city", "area", "park"], // 城市/区域/停车场
  "parkingLot-road": ["city", "area", "road", "park"], // 城市/区域/道路+停车场
  "parkingLot-roadSection": ["city", "area", "road", "park", "roadSection"] // 城市/区域/道路+停车场/路段
};

// 过滤层级数据
function filterLevel(list, type) {
  // 遍历跟数组 或者 children
  const returnArr = list.map(item => {
    const obj = {};
    const curType = item.type; // 获取类型
    // 如果没有类型 就是第一层 数据正常复制
    if (!curType) {
      for (const [key, value] of Object.entries(item)) {
        obj[key] = value; // 对象键和值 赋值
        obj["children"] = filterLevel(item.children, type);
      }
    } else {
      // 检测当前的对象的类型 是否我们需要的类型
      const isFilterType = filterTypes[type].includes(curType);
      // 如果不是 就直接退出当前对象的循环 并返回false (这里返回的false最后会在最终返回的时候给过滤掉)
      if (!isFilterType) {
        return false;
      }
      // 如果有类型 就说明进入了children
      for (const [key, value] of Object.entries(item)) {
        obj[key] = value; // 对象键和值 赋值
        // 判断是否有children
        if (key === "children" && value.length) {
          obj["children"] = filterLevel(item.children, type);
        }
      }
    }
    return obj;
  });
  return returnArr.filter(item => item); // 这里filter的原因 就是过滤掉false的数据
}

const state = () => {
  return {
    data:
      JSON.parse(window.localStorage.getItem("select-area-component-data")) ||
      [] // 全部的数据 城市/区域/道路/停车场|路段
  };
};

const getters = {
  // 过滤层级数据
  filterLevel(state) {
    return type => {
      return filterLevel(state.data, type);
    };
  }
};

const mutations = {
  SET_DATA(state, payload) {
    state.data = [...payload];
  }
};

const actions = {
  // 获取全部运营城市的列表
  async _getOperateCityList() {
    // const { data } = await getOperateCityList()
    const { data } = await getCityPage({
      pageNum: 1,
      pageSize: 99999
    });
    return data?.list ?? [];
  },
  // 根据城市获取全部区域的列表
  async _getOperateCityAreaList({ commit }, cityCode) {
    // const { data } = await getOperateCityAreaList(cityCode);
    const { data } = await byCityGetArea(cityCode);
    const areaList = data ?? [];
    return areaList;
  },
  // 根据区域获取全部道路的列表
  async _getOperateAreaRoadList({ commit }, areaCode) {
    const { data } = await getOperateAreaRoadList(areaCode);
    return data;
  },
  // 根据区域获取全部车场的列表
  async _byAreaCodeGetParkingLotList({ commit }, areaCode) {
    const { data } = await byAreaCodeGetParkingLotList(areaCode);
    return data;
  },
  // 根据道路获取全部路段的列表
  async _getOperateRoadSectionsList({ commit }, roadId) {
    const { data } = await getOperateRoadSectionsList(roadId);
    return data;
  },
  // 获取全部数据
  getCmpSelectAreaData({ commit, dispatch }) {
    console.time();
    console.log("vuex 选择区域组件重新获取数据");
    let timeOutTime = 0; // 初始延时时间
    const incrementTime = 50; // 递增时间
    return new Promise(async (resolve, reject) => {
      const citys = []; // 渲染的城市数据列表
      const cityList = await dispatch("_getOperateCityList");

      let cmpPromises = [];

      // 遍历城市
      cmpPromises = cityList.map(async cityItem => {
        return new Promise(async resolve => {
          const areas = []; // 渲染的区域列表
          const areaList = await dispatch(
            "_getOperateCityAreaList",
            cityItem.cityCode
          );

          let cityPromises = [];

          // 遍历区域
          cityPromises = areaList.map(async areaItem => {
            return new Promise(async resolve => {
              const roads = []; // 渲染的道路列表
              const parkingLots = []; // 渲染的停车场列表
              // await new Promise(resolve => setTimeout(resolve, 2000) )
              // const roadList = await dispatch(
              //   "_getOperateAreaRoadList",
              //   areaItem.id
              // );

              let areaPromises = [];

              // 遍历道路
              // areaPromises = roadList.map(async roadItem => {
              //   return new Promise(async resolve => {
              //     const roadSections = []; // 渲染的路段列表

              //     // count++
              //     // if (count >= maxCount) {
              //     //   count = 0
              //     //   time += coutnTime
              //     // }
              //     timeOutTime += incrementTime;

              //     await new Promise(resolve =>
              //       setTimeout(resolve, timeOutTime)
              //     );

              //     const roadSectionList = await dispatch(
              //       "_getOperateRoadSectionsList",
              //       roadItem.id
              //     );

              //     // 遍历路段
              //     roadSectionList.forEach(roadSectionItem => {
              //       // 如果 是路段属性 就显示路段
              //       roadSections.push({
              //         id: `${roadSectionItem.cityCode}-${roadSectionItem.areaCode}-${roadSectionItem.roadId}-${roadSectionItem.id}`,
              //         label: roadSectionItem.name,
              //         type: "roadSection"
              //       });
              //     });
              //     roads.push({
              //       label: roadItem.name,
              //       id: `${roadItem.cityCode}-${roadItem.areaCode}-${roadItem.id}`,
              //       type: "road",
              //       children: roadSections
              //     });
              //     resolve();
              //   });
              // });

              // await Promise.all(areaPromises);

              // console.log(roads);
              // const parkingLotList = await dispatch(
              //   "_byAreaCodeGetParkingLotList",
              //   areaItem.areaCode
              // );
              // // 遍历停车场
              // parkingLotList.forEach(parkingLotItem =>
              //   parkingLots.push({
              //     label: parkingLotItem.parkName,
              //     type: "park",
              //     id: `${parkingLotItem.cityCode}-${parkingLotItem.areaCode}-${parkingLotItem.id}$`
              //   })
              // );
              areas.push({
                id: `${areaItem.cityId}-${areaItem.id}`,
                label: areaItem.districtName,
                type: "area",
                children: [...roads, ...parkingLots]
              });

              resolve();
            });
          });

          await Promise.all(cityPromises);
          // 将城市数据添加掉对应城市列表中
          citys.push({
            id: cityItem.cityCode,
            label: cityItem.cityName,
            type: "city",
            children: areas
          });
          // 如果所有运营城市列表遍历完 就将城市列表 合并成一个新的列表 并替换掉树结构
          const pushData = [{ id: 0, label: "全部城市", children: citys }]; // 在拼接的城市数据中 外接一个最外层的全部城市的跟目录层
          citys.length >= cityList.length && commit("SET_DATA", pushData); // 如果已经遍历到最后一个的时候 就执行添加数据修改当前的state数据
          resolve();
          console.log(citys);
        });
      });

      await Promise.all(cmpPromises);
      resolve();
      window.localStorage.setItem(
        "select-area-component-data",
        JSON.stringify(citys)
      );
      console.log("本次执行获取城市区域组件全部数据的时间 ↓");
      console.timeEnd();
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
